export var SpaceRoutes;
(function (SpaceRoutes) {
    SpaceRoutes["SPACE"] = "customer/space";
})(SpaceRoutes || (SpaceRoutes = {}));
